import * as actionTypes from "./actionTypes";

export const fetchIntegrationDashboard = (payload) => {
  return {
    type: actionTypes.FETCH_INTEGRATION_DASHBOARD,
    payload,
  };
};

export const fetchIntegrationDashboardSuccess = (payload) => {
  return {
    type: actionTypes.FETCH_INTEGRATION_DASHBOARD_SUCCESS,
    payload,
  };
};

export const fetchIntegrationDashboardFailed = (payload) => {
  return {
    type: actionTypes.FETCH_INTEGRATION_DASHBOARD_FAILED,
    payload,
  };
};

export const downloadIntegrationDashboard = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_INTEGRATION_DASHBOARD,
    payload,
  };
};

export const downloadIntegrationDashboardSuccess = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_INTEGRATION_DASHBOARD_SUCCESS,
    payload,
  };
};

export const downloadIntegrationDashboardFailed = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_INTEGRATION_DASHBOARD_FAILED,
    payload,
  };
};

export const fetchIntegrationDashboardSummary = (payload) => {
  return {
    type: actionTypes.FETCH_INTEGRATION_DASHBOARD_SUMMARY,
    payload,
  };
};

export const fetchIntegrationDashboardSummarySuccess = (payload) => {
  return {
    type: actionTypes.FETCH_INTEGRATION_DASHBOARD_SUMMARY_SUCCESS,
    payload,
  };
};

export const fetchIntegrationDashboardSummaryFailed = (payload) => {
  return {
    type: actionTypes.FETCH_INTEGRATION_DASHBOARD_SUMMARY_FAILED,
    payload,
  };
};
